import axios from 'axios';

// For direct browser navigation (login/logout), we need the full URL
// In development, this points to the Flask backend directly
// In production, relative URLs work since everything is behind a reverse proxy
export const API_BASE_URL = process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'development' ? 'http://localhost:5001' : '');

export default axios.create({
    baseURL: `${API_BASE_URL}/api`
});
